module.exports = __webpack_public_path__ + "img/赵戌峰.663e1787.jpg";